// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayoutDefinitionCreateDto
 */
export interface IPayoutDefinitionCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IPayoutDefinitionCreateDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionCreateDto
     */
    organization_id: number;
    /**
     * 
     * @type {string}
     * @memberof IPayoutDefinitionCreateDto
     */
    organization_path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPayoutDefinitionCreateDto
     */
    is_limited_use?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionCreateDto
     */
    parent_id?: number;
}

/**
 * Check if a given object implements the IPayoutDefinitionCreateDto interface.
 */
export function instanceOfIPayoutDefinitionCreateDto(value: object): value is IPayoutDefinitionCreateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    return true;
}

export function IPayoutDefinitionCreateDtoFromJSON(json: any): IPayoutDefinitionCreateDto {
    return IPayoutDefinitionCreateDtoFromJSONTyped(json, false);
}

export function IPayoutDefinitionCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayoutDefinitionCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'organization_id': json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'is_limited_use': json['is_limited_use'] == null ? undefined : json['is_limited_use'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
    };
}

export function IPayoutDefinitionCreateDtoToJSON(json: any): IPayoutDefinitionCreateDto {
    return IPayoutDefinitionCreateDtoToJSONTyped(json, false);
}

export function IPayoutDefinitionCreateDtoToJSONTyped(value?: IPayoutDefinitionCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'is_limited_use': value['is_limited_use'],
        'parent_id': value['parent_id'],
    };
}

